module.exports = __webpack_public_path__ + "static/scoping-c7deb9121ecb23f202466824473dbefa.png";